import { render, staticRenderFns } from "./RestartExperienceButtonWrapper.vue?vue&type=template&id=4eb39bbc&"
import script from "./RestartExperienceButtonWrapper.vue?vue&type=script&lang=js&"
export * from "./RestartExperienceButtonWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports